enum ReportPage {
    Success,
    ErrorWarning,
    Expired
}

export default ReportPage